module.exports = __webpack_public_path__ + "ad565d235d00abcd254b481040f82730.fbx";